module.exports = __webpack_public_path__ + "static/media/notification_alert_icon.4da9c32a.svg";